import Env from "../base/env";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);
import easesCustom from "../fx/CustomEases";

function detectOffsetStart(el) {
  let offsetStart;
  if (typeof el.getAttribute("data-start") != "undefined") {
    offsetStart = el.getAttribute("data-start");
  }
  if (
    Env.mobileCSS &&
    typeof el.getAttribute("data-start-mobile") != "undefined"
  ) {
    offsetStart = el.getAttribute("data-start-mobile");
  }
  return offsetStart;
}

export function calculateMask(el, direction, type = "width") {
  const dimensions = el.getBoundingClientRect();
  let value;
  if (direction == "from") {
    if (type == "width") {
      value = `rect(0px,0px,${dimensions.height}px,0)`;
    } else {
      value = `rect(0px,${dimensions.width}px,0px,0)`;
    }
  } else if (direction == "to") {
    value = `rect(0px,${dimensions.width}px,${dimensions.height}px,0)`;
  }
  return value;
}

export function RevealFadeX(el) {
  let offsetStart = Env.mobileCSS ? "top 90%" : "top 50%";
  offsetStart = detectOffsetStart(el);
  let value = 50;
  if (typeof el.getAttribute("data-direction") != "undefined") {
    value *= el.getAttribute("data-direction");
  }
  let delayFx =
    typeof el.getAttribute("data-delay") != undefined
      ? el.getAttribute("data-delay")
      : 0;
  gsap.fromTo(
    el,
    {
      autoAlpha: 0,
      x: value,
    },
    {
      autoAlpha: 1,
      x: 0,
      duration: 1.5,
      ease: "quint.out",
      delay: delayFx * 1,
      onStart: () => {
        el.classList.add("is-animated");
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function RevealFadeY(el) {
  let offsetStart = Env.mobileCSS ? "top 90%" : "top 50%";
  offsetStart = detectOffsetStart(el);
  let delayFx =
    typeof el.getAttribute("data-delay") != undefined
      ? el.getAttribute("data-delay")
      : 0;

  gsap.fromTo(
    el,
    {
      autoAlpha: 0,
      y: 50,
    },
    {
      autoAlpha: 1,
      y: 0,
      duration: 1.5,
      ease: "quint.out",
      delay: delayFx * 1,
      onStart: () => {
        el.classList.add("is-animated");
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function RevealFade(el) {
  let offsetStart = Env.mobileCSS ? "top 90%" : "top 60%";
  offsetStart = detectOffsetStart(el);
  let delayFx =
    typeof el.getAttribute("data-delay") != undefined
      ? el.getAttribute("data-delay")
      : 0;
  gsap.fromTo(
    el,
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
      duration: 1.5,
      ease: "cubic.inOut",
      delay: delayFx * 1,
      onStart: () => {
        setTimeout(() => {
          el.classList.add("is-animated");
        }, 400);
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function RevealScale(el) {
  let offsetStart = Env.mobileCSS ? "top 90%" : "top 60%";
  offsetStart = detectOffsetStart(el);
  let delayFx =
    typeof el.getAttribute("data-delay") != undefined
      ? el.getAttribute("data-delay")
      : 0;
  gsap.fromTo(
    el,
    {
      scale: 1.1,
    },
    {
      scale: 1,
      duration: 1.5,
      ease: "quint.out",
      delay: delayFx * 1,
      onStart: () => {
        setTimeout(() => {
          el.classList.add("is-animated");
        }, 400);
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function RevealScaleOut(el) {
  let offsetStart = Env.mobileCSS ? "top 90%" : "top 60%";
  offsetStart = detectOffsetStart(el);
  let delayFx =
    typeof el.getAttribute("data-delay") != undefined
      ? el.getAttribute("data-delay")
      : 0;
  gsap.fromTo(
    el,
    {
      scale: 0.9,
    },
    {
      scale: 1,
      duration: 1.5,
      ease: "quint.out",
      delay: delayFx * 1,
      onStart: () => {
        setTimeout(() => {
          el.classList.add("is-animated");
        }, 400);
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function RevealFadeOut(el) {
  let offsetStart = Env.mobileCSS ? "top 90%" : "top 60%";
  offsetStart = detectOffsetStart(el);
  let delayFx =
    typeof el.getAttribute("data-delay") != undefined
      ? el.getAttribute("data-delay")
      : 0;
  gsap.fromTo(
    el,
    {
      autoAlpha: 1,
    },
    {
      autoAlpha: 0,
      duration: 0.8,
      ease: easesCustom.cubic,
      delay: delayFx * 1,
      onStart: () => {
        el.classList.add("is-animated");
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function RevealMask(el) {
  let offsetStart = Env.mobileCSS ? "top 90%" : "top 60%";
  offsetStart = detectOffsetStart(el);
  let delayFx =
    typeof el.getAttribute("data-delay") != undefined
      ? el.getAttribute("data-delay")
      : 0;
  gsap.fromTo(
    el,
    {
      y: "150%",
    },
    {
      y: 0,
      duration: 0.8,
      ease: easesCustom.quart,
      delay: delayFx * 1,
      onStart: () => {
        el.classList.add("is-animated");
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function prepareToFx() {
  gsap.set(document.querySelectorAll(".fxVisualHide"), { autoAlpha: 0 });
}

export function InteractiveModuleRevealText(DOM, FX, cb) {
  gsap.killTweensOf(DOM.bar);
  gsap.killTweensOf(FX.title.chars);
  gsap.killTweensOf(FX.desc.lines);
  gsap.fromTo(
    DOM.bar,
    {
      transformOrigin: "left top",
      scaleY: 0,
    },
    {
      scaleY: 1,
      duration: 0.7,
      ease: "quint.out",
    }
  ),
    gsap.fromTo(
      FX.title.chars,
      {
        autoAlpha: 0,
        y: -5,
      },
      {
        autoAlpha: 1,
        y: 0,
        stagger: 0.05,
        ease: "quint.out",
        duration: 0.6,
      }
    ),
    gsap.fromTo(
      FX.desc.lines,
      {
        autoAlpha: 0,
        y: -15,
      },
      {
        autoAlpha: 1,
        y: 0,
        stagger: 0.05,
        ease: "quint.out",
        duration: 0.8,
        delay: 0.2,
        onComplete: () => {
          if (typeof cb != "undefined" && typeof cb == "function") {
            cb();
          }
        },
      }
    );
}

// export function CardHoverBase(item) {
//   const DOM = {
//     hoverIn: item.querySelector(".fx-hover-in"),
//     hoverOut: item.querySelector(".fx-hover-out"),
//   };
//   const FX = {
//     type: "quart.inOut",
//     duration: 0.65,
//   };
//   let RAF;
//   let CAN_LEAVE = false;
//   if (Env.mobileCSS == false) {
//     item.addEventListener("mouseenter", () => {
//       CAN_LEAVE = true;
//       const tl = gsap.timeline();
//       tl.add([
//         gsap.fromTo(
//           DOM.hoverIn,
//           {
//             x: "100%",
//           },
//           {
//             x: "0%",
//             ease: FX.type,
//             duration: FX.duration,
//           }
//         ),
//         gsap.fromTo(
//           DOM.hoverOut,
//           {
//             x: "0%",
//           },
//           {
//             x: "-50%",
//             ease: FX.type,
//             duration: FX.duration,
//             onComplete: () => (CAN_LEAVE = false),
//           }
//         ),
//       ]);
//     });
//     item.addEventListener("mouseleave", () => {
//       watcherOut();
//     });
//   }

//   function leaving() {
//     const tl = gsap.timeline();
//     tl.add([
//       gsap.fromTo(
//         DOM.hoverOut,
//         {
//           x: "120%",
//           zIndex: 10,
//         },
//         {
//           x: "0%",
//           ease: FX.type,
//           duration: FX.duration,
//           onComplete: () => {
//             gsap.set(DOM.hoverOut, { clearProps: "zIndex" });
//           },
//         }
//       ),
//       gsap.fromTo(
//         DOM.hoverIn,
//         {
//           x: "0%",
//           zIndex: 1,
//         },
//         {
//           x: "-50%",
//           ease: FX.type,
//           duration: FX.duration,
//           onComplete: () => {
//             gsap.set(DOM.hoverIn, { clearProps: "transform,zIndex" });
//           },
//         }
//       ),
//     ]);
//   }

//   function watcherOut() {
//     RAF = requestAnimationFrame(() => {
//       watcherOut();
//       if (CAN_LEAVE == false) {
//         leaving();
//         cancelAnimationFrame(RAF);
//       }
//     });
//   }
// }

export function CardHoverBase(item) {
  const DOM = {
    hoverIn: item.querySelector(".fx-hover-in"),
    hoverOut: item.querySelector(".fx-hover-out"),
  };

  if (Env.mobileCSS == false) {
    item.addEventListener("mouseenter", () => {
      gsap.fromTo(
        DOM.hoverIn,
        { autoAlpha: 0, x: 0, scale: 1 },
        { autoAlpha: 1, ease: "linear", duration: 0 }
      );
      gsap.fromTo(
        DOM.hoverOut,
        { autoAlpha: 1 },
        { autoAlpha: 0, ease: "linear", duration: 0 }
      );
    });
    item.addEventListener("mouseleave", () => {
      gsap.killTweensOf(DOM.hoverIn);
      gsap.set(DOM.hoverIn, { autoAlpha: 0 });
      gsap.set(DOM.hoverOut, { autoAlpha: 1 });
    });
  }
}

export function TextHoverSlide(item) {
  item.classList.add("moducss-hovertext-slide");
  const DOM = {
    textOut: item.querySelector(".txt-out"),
    textIn: item.querySelector(".txt-in"),
  };
  DOM.textIn.innerHTML = DOM.textOut.innerHTML;
  // prettier-ignore
  const instanceOut = new SplitText(DOM.textOut, { type: "words", wordsClass:"tw-overflow-hidden" });
  // prettier-ignore
  const instanceOutAlt = new SplitText(DOM.textOut, { type: "words", wordsClass:"fx-hovertext-out" });
  // prettier-ignore
  const instanceIn = new SplitText(DOM.textIn, { type: "words", wordsClass:"tw-overflow-hidden" });
  // prettier-ignore
  const instanceInAlt = new SplitText(DOM.textIn, { type: "words", wordsClass:"fx-hovertext-in" });

  // this.fxHoverTxt.out.push(instanceOut);
  // this.fxHoverTxt.in.push(instanceIn);
}

export function CharHoverSlide(item) {
  item.classList.add("moducss-hoverchar-slide");
  const DOM = {
    textOut: item.querySelector(".txt-out"),
    textIn: item.querySelector(".txt-in"),
  };
  DOM.textIn.innerHTML = DOM.textOut.innerHTML;
  const instanceLineIn = new SplitText(DOM.textIn, {
    type: "lines",
    linesClass: "fx-line",
  });
  const instanceLineOut = new SplitText(DOM.textOut, {
    type: "lines",
    linesClass: "fx-line",
  });
  // prettier-ignore
  const instanceOut = new SplitText(DOM.textOut, { type: "chars", charsClass:"tw-overflow-hidden chars-parent" });
  // prettier-ignore
  const instanceOutAlt = new SplitText(DOM.textOut, { type: "chars", charsClass:"fx-hovertext-out" });
  // prettier-ignore
  const instanceIn = new SplitText(DOM.textIn, { type: "chars", charsClass:"tw-overflow-hidden chars-parent" });
  // prettier-ignore
  const instanceInAlt = new SplitText(DOM.textIn, { type: "chars", charsClass:"fx-hovertext-in" });

  // this.fxHoverTxt.out.push(instanceOut);
  // this.fxHoverTxt.in.push(instanceIn);
}
